// extracted by mini-css-extract-plugin
export var dropdown = "_hw-0";
export var imagePlaceholder = "_hw-2";
export var imageWrapper = "_hw-3";
export var productImage = "_hw-1";
export var truncateContainer = "_hw-4";
export var truncateText = "_hw-5";